<template>
  <section
    v-if="visible"
    class="cc-sheet"
  >
    <header class="cc-sheet__head cc-sheet__head--row">
      <div>
        <h2>{{ $t('convertCoordinates.results.title') }}</h2>
        <p>{{ $t('convertCoordinates.results.subtitle') }}</p>
      </div>
      <div class="cc-toolbar__actions">
        <button
          type="button"
          class="cc-btn cc-btn--ghost"
          :disabled="!rows.length"
          @click="$emit('copy-all')"
        >
          <feather-icon
            icon="CopyIcon"
            size="14"
          />
          {{ $t('convertCoordinates.actions.copyCsv') }}
        </button>
        <button
          type="button"
          class="cc-btn cc-btn--ghost"
          :disabled="!rows.length"
          @click="$emit('download-csv')"
        >
          <feather-icon
            icon="DownloadIcon"
            size="14"
          />
          {{ $t('convertCoordinates.actions.downloadCsv') }}
        </button>
      </div>
    </header>

    <div
      v-if="!rows.length"
      class="cc-empty"
    >
      {{ $t('convertCoordinates.results.empty') }}
    </div>

    <template v-else>
      <div class="cc-table-scroll">
        <table class="cc-table cc-table--results">
          <thead>
            <tr>
              <th>#</th>
              <th>{{ $t('convertCoordinates.fields.name') }}</th>
              <th>{{ $t('convertCoordinates.fields.latitude') }}</th>
              <th>{{ $t('convertCoordinates.fields.longitude') }}</th>
              <th>{{ $t('convertCoordinates.fields.utmEast') }}</th>
              <th>{{ $t('convertCoordinates.fields.utmNorth') }}</th>
              <th>{{ $t('convertCoordinates.fields.utmZone') }}</th>
              <th>{{ $t('convertCoordinates.fields.etmEast') }}</th>
              <th>{{ $t('convertCoordinates.fields.etmNorth') }}</th>
              <th>{{ $t('convertCoordinates.fields.etmZone') }}</th>
              <th>{{ $t('convertCoordinates.fields.dms') }}</th>
              <th>{{ $t('convertCoordinates.fields.sourceSystem') }}</th>
              <th />
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, rowIndex) in pagedRows"
              :key="`converted-${page}-${rowIndex}-${row.index}`"
            >
              <td>{{ rowStart + rowIndex }}</td>
              <td>{{ formatValue(row.name) }}</td>
              <td>{{ formatValue(row.latitude) }}</td>
              <td>{{ formatValue(row.longitude) }}</td>
              <td>{{ formatValue(row.utm_east) }}</td>
              <td>{{ formatValue(row.utm_north) }}</td>
              <td>{{ formatValue(row.utm_zone) }}</td>
              <td>{{ formatValue(row.etm_east) }}</td>
              <td>{{ formatValue(row.etm_north) }}</td>
              <td>{{ formatValue(row.etm_zone) }}</td>
              <td class="cc-dms">
                {{ dmsLabel(row) }}
              </td>
              <td>{{ formatValue(row.coordinate_system) }}</td>
              <td>
                <button
                  type="button"
                  class="cc-icon-btn"
                  :title="$t('convertCoordinates.actions.copyRow')"
                  @click="$emit('copy-row', row)"
                >
                  <feather-icon
                    icon="CopyIcon"
                    size="14"
                  />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        v-if="rows.length > perPage"
        class="cc-pager"
      >
        <button
          type="button"
          class="cc-btn cc-btn--ghost"
          :disabled="page <= 1"
          @click="page -= 1"
        >
          {{ $t('convertCoordinates.pager.prev') }}
        </button>
        <span>{{ page }} / {{ pageCount }}</span>
        <button
          type="button"
          class="cc-btn cc-btn--ghost"
          :disabled="page >= pageCount"
          @click="page += 1"
        >
          {{ $t('convertCoordinates.pager.next') }}
        </button>
      </div>
    </template>
  </section>
</template>

<script>
import { formatCoordValue } from '../utils/coordinateRows'

export default {
  name: 'ConvertedResultsTable',
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      page: 1,
      perPage: 50,
    }
  },
  computed: {
    pageCount() {
      return Math.max(1, Math.ceil(this.rows.length / this.perPage))
    },
    pagedRows() {
      const start = (this.page - 1) * this.perPage
      return this.rows.slice(start, start + this.perPage)
    },
    rowStart() {
      return (this.page - 1) * this.perPage + 1
    },
  },
  watch: {
    rows() {
      this.page = 1
    },
  },
  methods: {
    formatValue: formatCoordValue,
    dmsLabel(row) {
      const lat = formatCoordValue(row.dms_latitude)
      const lon = formatCoordValue(row.dms_longitude)
      if (lat === '—' && lon === '—') return '—'
      return `${lat} / ${lon}`
    },
  },
}
</script>
